import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchACHCompanies: (queryString?: string) => {
    const formattedQueryString = queryString ? `?${queryString}` : "";
    return {
      url: `ach_companies${formattedQueryString}`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
};
